import { createSelector } from 'reselect'
import {
    getGroupIndex,
    getMediaIndex
} from 'redux/navigation/selectors'

export const getMediaInfo = state => state.mediaInfo

export const getCurrentMediaInfo = createSelector(
    getMediaInfo,
    getGroupIndex,
    getMediaIndex,
    (mediaInfo, groupIndex, mediaIndex) => {
        if(! mediaInfo[groupIndex])
        {
            return {}
        }
        return mediaInfo[groupIndex][mediaIndex] || {}
    }
)
